import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { CustomHttpUrlEncodingCodec } from '@app/_helpers';
import * as _ from 'lodash';


@Injectable({
    providedIn: 'root'
})
export class ProductPageService {
    constructor(private http: HttpClient) { }

    getProduct(id, preview = false): Observable<any> {
        let params = "";
        if (preview) {
            params = `?preview=${preview}`
        }
        return this.http.get<any>(`${environment.apiUrl}/products/${id}${params}`);
    }

    getPropertiesNearby(id, preview = false): Observable<any> {
        let params = "";
        if (preview) {
            params = `?preview=${preview}`
        }
        return this.http.get<any>(`${environment.apiUrl}/products/nearby-properties/${id}${params}`);
    }


    getChangedOption({ slug, options, serviceData, amount }: any = {}): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/products/check-option/${slug}`, { options: options, serviceData: serviceData, amount: amount });
    }

    getSectorProducts(sector, params): Observable<any> {
        let filterParams: HttpParams = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec()
        });
        if (params) {
            _.forEach(params, (value, key) => {
                filterParams = filterParams.append(key, value)
            });
        }
        return this.http.get<any>(`${environment.apiUrl}/products/sector/${sector}`, { params: filterParams });
    }


    getProductName(id: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/products/name/${id}`).pipe(
            catchError(error => {
                return of(null);
            })
        );
    }


    public optionVariants$: BehaviorSubject<any> = new BehaviorSubject(false);
}
